module.exports = fp;


//////////////////
// WEBPACK FOOTER
// external "fp"
// module id = 16
// module chunks = 0